export default __webpack_public_path__ + "c08ca288ea732af6035681750297bb3d.svg";